import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  // The values that are defined here are the default values that can be overridden by env.js

  public APP_TYPE = "WEB_APP";

  public BASE_URL = "";
  public API_DOC_BASE_URL = "";
  public B2B_URL = ""; // Used in PDF

  public SWAGGER_HOST = "";
  public PORTAL = "b2b"; // Used for Getting swagger resource

  public LOCALE = "en-US";

  public COUNTRY = "US";

  public MODE = "ADMIN";

  public ENV = "";

  public PORTAL_APP_TYPE = new Map([
    ["ADMIN", 'B2B_ADMIN_PORTAL'],
    ["DEVELOPER", 'B2B_DEVELOPER_PORTAL']
  ]);

  public SHOW_STREAMING = false; // Used to enable or disable the Streaming option in the UI

  public SHOW_PAYMENT = true; // Used to enable or disable the Streaming option in the UI

  public UNSUPPORTED_USER_AUTO_LOGOUT_TIME = 15000; // Used to logout unsupported user after specified miliseconds.

  // MOVE the below code to env.js when required.
  /** Data Type: boolean, Accepted Values: [true, false], Default Value: false */
  // window.__env.ENABLE_IDLE_CHECK = false;

  /** Data Type: Number, Default Value: 30 (in seconds) */
  // window.__env.IDLE_TIME_THRESHOLD = 10;
  public ENABLE_IDLE_CHECK = false;
  public IDLE_TIME_THRESHOLD = 30;
  public REGION = "NA";

  constructor() {
  }
}
